import React, { useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { getCookieConsentValue } from 'react-cookie-consent';
import ReactGA from 'react-ga';
import Simulador from './components/pages/simulador';
import Settings from './components/pages/settings';
import AlertaCookie from './components/organisms/AlertaCookie';
import hotjar from './services/util/hotjar';
import AuthenticationProvider from './authenticationProvider';
import DefaultTemplate from './components/templates/default';

function Router() {
  const cookieName = 'cookieSimulador';
  const [isCookiesGranted, setIsCookiesGranted] = useState(
    () => getCookieConsentValue(cookieName) === 'true'
  );
  if (isCookiesGranted && process.env.NODE_ENV === 'production') {
    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
    ReactGA.pageview(window.location.pathname);
    hotjar.initialize(
      process.env.REACT_APP_HOTJAR_ID,
      process.env.REACT_APP_HOTJAR_VERSION
    );
  }

  return (
    <>
      <BrowserRouter>
        <Switch>
          <AuthenticationProvider>
            <DefaultTemplate>
              <Route path="/" exact component={Simulador} />
              <Route path="/settings" exact component={Settings} />
            </DefaultTemplate>
          </AuthenticationProvider>
        </Switch>
      </BrowserRouter>

      <AlertaCookie
        cookieName={cookieName}
        onAccept={() => setIsCookiesGranted(true)}
      />
    </>
  );
}

export default Router;
